// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_MigrarAssinaturaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de POST /migration/assinaturas/migrar-todas
 * (controllers/migration/assinaturas.php::migrar_todas).
 *
 * A MESMA validacao do pre-voo, de proposito: as duas portas recusam o mesmo
 * pedido malformado com a mesma mensagem.
 */
import { registerContract } from './validate'

export interface Migration_MigrarAssinaturaInput {
zoho_id_unidade?: string
data_ini?: string
data_fim?: string
ids?: string
}

registerContract('Migration_MigrarAssinaturaInput', {
  zoho_id_unidade: { type: 'string',  required: false },
  data_ini:        { type: 'string',  required: false },
  data_fim:        { type: 'string',  required: false },
  ids:             { type: 'string',  required: false },
})
